import ChangePassword from '../../../../presentation/pages/change-password'
import { useGame } from '../../../../presentation/contexts'

const MakeChangePassword = () => {
  const { isTogether } = useGame()

  if (isTogether()) {
    return <ChangePassword />
  }

  return null
}

export default MakeChangePassword
